import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Icon } from '@iconify/react';

const TaxRuleModal = ({ show, handleClose, handleSubmit, formData, setFormData, editId, loading }) => {

    // Calculate IGST for display
    const calculateTotalTax = (cgst, sgst) => {
        return (parseFloat(cgst || 0) + parseFloat(sgst || 0)).toFixed(2);
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title className="fw-semibold">
                    {editId ? 'Edit' : 'Create'} Tax Rule
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body className="p-24">
                    <div className="row gy-3">
                        <div className="col-12">
                            <Form.Group controlId="ruleName">
                                <Form.Label className="text-secondary-light text-sm fw-medium mb-1">
                                    Rule Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    className="radius-8 h-48-px"
                                    value={formData.rule_name}
                                    onChange={(e) => setFormData({ ...formData, rule_name: e.target.value })}
                                    required
                                    placeholder="e.g. GST 18%"
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group controlId="code">
                                <Form.Label className="text-secondary-light text-sm fw-medium mb-1">
                                    Code <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    className="radius-8 h-48-px"
                                    value={formData.code}
                                    onChange={(e) => setFormData({ ...formData, code: e.target.value })}
                                    required
                                    placeholder="e.g. 9997"
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group controlId="codeType">
                                <Form.Label className="text-secondary-light text-sm fw-medium mb-1">
                                    Code Type
                                </Form.Label>
                                <Form.Select
                                    className="radius-8 h-48-px"
                                    value={formData.code_type}
                                    onChange={(e) => setFormData({ ...formData, code_type: e.target.value })}
                                >
                                    <option value="SAC">SAC</option>
                                    <option value="HSN">HSN</option>
                                </Form.Select>
                            </Form.Group>
                        </div>

                        <div className="col-12">
                            <Form.Group controlId="description">
                                <Form.Label className="text-secondary-light text-sm fw-medium mb-1">
                                    Description
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    className="radius-8 h-48-px"
                                    value={formData.description}
                                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                    placeholder="Brief description"
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group controlId="rateCgst">
                                <Form.Label className="text-secondary-light text-sm fw-medium mb-1">
                                    CGST (%) <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    className="radius-8 h-48-px"
                                    value={formData.rate_cgst}
                                    onChange={(e) => setFormData({ ...formData, rate_cgst: parseFloat(e.target.value) })}
                                    required
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group controlId="rateSgst">
                                <Form.Label className="text-secondary-light text-sm fw-medium mb-1">
                                    SGST (%) <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    className="radius-8 h-48-px"
                                    value={formData.rate_sgst}
                                    onChange={(e) => setFormData({ ...formData, rate_sgst: parseFloat(e.target.value) })}
                                    required
                                />
                            </Form.Group>
                        </div>

                        <div className="col-12">
                            <Form.Group controlId="rateIgst">
                                <Form.Label className="text-secondary-light text-sm fw-medium mb-1">
                                    IGST (%)
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    className="radius-8 h-48-px"
                                    value={formData.rate_igst}
                                    onChange={(e) => setFormData({ ...formData, rate_igst: parseFloat(e.target.value) })}
                                    placeholder="For inter-state rules"
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group controlId="thresholdLimit">
                                <Form.Label className="text-secondary-light text-sm fw-medium mb-1">
                                    Threshold Limit
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    className="radius-8 h-48-px"
                                    value={formData.threshold_limit}
                                    onChange={(e) => setFormData({ ...formData, threshold_limit: parseFloat(e.target.value) })}
                                    placeholder="e.g. 7500"
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group controlId="thresholdLogic">
                                <Form.Label className="text-secondary-light text-sm fw-medium mb-1">
                                    Threshold Logic
                                </Form.Label>
                                <Form.Select
                                    className="radius-8 h-48-px"
                                    value={formData.threshold_logic}
                                    onChange={(e) => setFormData({ ...formData, threshold_logic: e.target.value })}
                                >
                                    <option value="EXEMPT_BELOW">Exempt Below Limit</option>
                                    <option value="TAX_EXCESS">Tax Only Excess</option>
                                    <option value="TAX_ALL">Tax Full Amount</option>
                                </Form.Select>
                            </Form.Group>
                        </div>

                        <div className="col-12 pt-2">
                            <div className="alert alert-info py-2 d-flex align-items-center gap-2">
                                <Icon icon="mdi:calculator" className="text-lg" />
                                <span>
                                    Total Tax (Intra-state) will be <strong>{calculateTotalTax(formData.rate_cgst, formData.rate_sgst)}%</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="py-10 px-16 border-top">
                    <Button variant="outline-secondary px-20 py-10 radius-8" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="warning px-20 py-10 radius-8 text-white"
                        style={{ backgroundColor: '#f59e0b', borderColor: '#f59e0b' }}
                        disabled={loading}
                    >
                        {loading && (
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                        )}
                        {editId ? 'Update' : 'Create'} Rule
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default TaxRuleModal;
